import { format } from "date-fns";

export function DateFix(oldDate: Date | string, dateFormat = "dd/MM/yyyy"): string {
  if (oldDate === null || oldDate === undefined)
    return "";

  if (typeof oldDate === "string" && oldDate === "")
    return "";

  return format(new Date(oldDate), dateFormat);
}